export default __webpack_public_path__ + "e897018c26e2ffcff8501a92a26e9acd.png";